import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { setModal, selectModal } from "../../../redux/modalSlice";
import { useForm } from 'react-hook-form'
import { useRequest } from '../../../hooks/UseRequest'
import { setNotification } from "../../../redux/notificationSlice";
import { triggerRerender } from "../../../redux/rerenderSlice";

export default function CustomerResendEmailModal() {
  const dispatch = useDispatch();
  const modal = useSelector(selectModal);
  const { formState: { errors }, reset } = useForm();
  const [saving, setSaving] = useState(false)
  const request = useRequest()
  const emailMessage = modal.options?.emailMessage
  const customerEmailAddress = modal.options?.customerEmailAddress

  const handleResendEmail = async () => {
    setSaving(true);
    request.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/customer/${emailMessage?.customer_id}/email_message/${emailMessage?.id}/resend`)
    try {
      const response = await request.post()
      if (response.status === 200 || response.status === 201) {
        setSaving(false)
        dispatch(triggerRerender({ subpanelId: 'customer_email_message' }))
        dispatch(setModal({ is_active: false }));
      } else {
        setSaving(false)
        dispatch(setNotification({ type: 'error', body: `Error: ${response.status}` }))
      }
    } catch (error) {
      setSaving(false)
      const errorMessage = error?.response?.data?.message ?? error?.response?.data?.messageExtreme
      dispatch(setNotification({ type: 'error', body: errorMessage }))
    }
  }
  const handleCancel = () => {
    dispatch(setModal({ is_active: false }));
    reset();
  };

  return modal.is_active && modal.type === 'customer_resend_email_modal' ? (
    <div className="modal is-active">
      <div className="modal-background"></div>
      <div className="modal-card column is-3">
        <header className="modal-card-head py-3">
          <p className="modal-card-title is-capitalized">
            Resend Email Confirmation
          </p>
          <button className="delete" aria-label="close" onClick={handleCancel}></button>
        </header>
        <section
          className="modal-card-body modal-card-body pt-1 pb-1"
          style={{ minHeight: "100px", overflow: 'hidden' }}
        >
          <div className="columns mb-0 is-flex-direction-column mt-3">
            <div className="column">
             <h3>Are you sure you want to resend the same email to the customer? This will use the current email address for the customer including any overrides from POA, DMC, C&D, etc.</h3>
            </div>
            <div className="column">
              <label className="has-text-weight-bold">Subject: </label>
              <span>{emailMessage.subject}</span>
            </div>
            <div className="column">
              <label className="has-text-weight-bold">Template: </label>
              <span>{emailMessage.template_label}</span>
            </div>
            <div className="column">
              <label className="has-text-weight-bold">Customer: </label>
              <span>{emailMessage.customer_label}</span>
            </div>
            <div className="column">
              <label className="has-text-weight-bold">Customer Email: </label>
              <span>{customerEmailAddress ?? emailMessage.recipient_email_address}</span>
            </div>
            {emailMessage.loan_id && (
              <div className="column">
                <label className="has-text-weight-bold">Loan Id: </label>
                <span>{emailMessage.loan_id}</span>
              </div>
            )}
            {emailMessage.lead_id && (
              <div className="column">
                <label className="has-text-weight-bold">Loan Id: </label>
                <span>{emailMessage.lead_id}</span>
              </div>
            )}
            {emailMessage.payment_id && (
              <div className="column">
                <label className="has-text-weight-bold">Payment Id: </label>
                <span>{emailMessage.payment_id}</span>
              </div>
            )}
          </div>
        </section>
        <footer className="modal-card-foot is-justify-content-end py-1">
          <div className="lox-form__buttons-wrapper has-text-right">
            <button type="button" className="button is-small has-background-grey has-text-white" onClick={handleCancel}>Cancel</button>
            <button type="button" onClick={handleResendEmail} className="button is-link is-small" disabled={saving && 'disabled'}>{saving ? 'Sending' : 'ReSend'}</button>
          </div>
        </footer>
      </div>
    </div>
  ) : null;
}
